import { t } from '@gem/modules/i18n';

const fieldsToDirectMap = [
  'id',
  'name',
  'avatarUrl',
  'categoryId',
  'usersCount',
  'type',
  'deepLinkInfo',
  'userGroupRole',
  'categoryInfo',
  'draftInput',
  'memberCustomPermissions',
  'descriptionMentions',
  'unread',
  'spaceId',
  'settings',
  'showContent',
  'obsceneFilterEnabled',
  'keywordFilters',
  'ttlPeriodMs',
];

const textFieldsToDirectMap = ['description', 'donationUrl'];

export const updateDirectFields = (sourceObject, targetObject) => {
  const target = targetObject;

  fieldsToDirectMap.forEach((field) => {
    if (sourceObject[field] !== undefined) {
      target[field] = sourceObject[field];
    }
  });

  textFieldsToDirectMap.forEach((field) => {
    if (typeof sourceObject[field] === 'string') {
      target[field] = sourceObject[field];
    }
  });
};

export const updateIndirectFields = (sourceObject, targetObject) => {
  const target = targetObject;

  target.avatarUrl = sourceObject.avatarUrl;
  target._verified = sourceObject.verified;
  if (sourceObject.opponent) {
    target.opponentId = sourceObject.opponent.id;
    target.avatarUrl = sourceObject.opponent.avatarUrl;
  }

  if (sourceObject.botOpponent) {
    target.botOpponentId = sourceObject.botOpponent.id;
    target.avatarUrl = sourceObject.botOpponent.avatarUrl;
  }

  if (sourceObject.botOpponent && sourceObject.botOpponent.deleted) {
    target.description = t('deleted_bot_input_menu');
  }

  target.muted = sourceObject.muted;
  target.pinOrder = sourceObject.pinOrder;
  target.blurred = sourceObject.blurred;

  if (sourceObject.pinnedMessageIds?.length) {
    target.pinnedMessages.clear();
    target.pinnedMessages.set(sourceObject.pinnedMessageIds);
  } else {
    target.pinnedMessages.clear();
  }
};
